import { PlaybackBaseEventData } from './playback-base-event-data';

export enum PlaybackAction {
  firstPlay = 'FIRST_PLAY',
  play = 'PLAY',
  pause = 'PAUSE',
  seek = 'SEEK',
  stop = 'STOP',
  ff = 'FF',
  rw = 'RW',
  finish = 'FINISH',
}

export class PlaybackEventArgs extends PlaybackBaseEventData {
  readonly playbackAction: PlaybackAction;

  constructor(data: PlaybackEventArgs) {
    super('playbackAction', data as PlaybackBaseEventData);
    this.playbackAction = data.playbackAction;
  }
}
